import React, { useState, useEffect } from 'react';
import Filters from '../../../components/Filters';
import { Form } from 'react-bootstrap';
import MultiSelectField from '../../../components/form/MultiSelectField';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Multiselect from 'multiselect-react-dropdown';

const FiltersPartial = (props) => {
    const { filtersModel, setFiltersModel } = props;
    const [selectedFromDate, setSelectedFromDate] = useState(filtersModel?.start_date || null);
    const [selectedToDate, setSelectedToDate] = useState(filtersModel?.end_date || null);
    const [dateError, setDateError] = useState(false);
    const options = [
        {id: "draft", name: "draft"},
        {id: "submitted", name: "submitted"},
        {id: "system_amount_refused", name: "system_amount_refused"},
        {id: "approved", name: "approved"},
        {id: "paid", name: "paid"},
        {id: "claim_revision_cp", name: "claim_revision_cp"},
        {id: "hold", name: "hold"},
    ]

    const onStatusAdded = (selectedItems, selectedOption) => {
        setFiltersModel((prevState) => {
            return { ...prevState, status: [...(prevState?.status || []), selectedOption.id] }
        })
    }

    const onStatusRemove = (selectedItems, removedOption) => {
        setFiltersModel((prevState) => {
            return { ...prevState, status: prevState.status.filter((id) => id !== removedOption.id) }
        })
    }

    const handleFromDateChange = (date) => {
        if (date) {
            setDateError(false);
            let formattedDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
            setSelectedFromDate(date);

            setFiltersModel((prevState) => {
                return { ...prevState, start_date: formattedDate }
            })
        }
    }

    const handleToDateChange = (date) => {
        if (date) {
            if (selectedFromDate) {
                setDateError(false);
                let formattedDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
                setSelectedToDate(date);

                setFiltersModel((prevState) => {
                    return { ...prevState, end_date: formattedDate }
                })
            }
            else {
                setDateError(true);
            }
        }
    }

    return <Filters filtersModel={filtersModel} setFiltersModel={setFiltersModel}>
        <div>
            <Form.Group className="mb-3">
                <Form.Label>Status</Form.Label>
                <Multiselect
                  id="props.id"
                  options={options}
                  selectedValues={(()=> options.filter(option => filtersModel?.status?.find(sta => option.id === sta)))()}
                  onSelect={onStatusAdded}
                  onRemove={onStatusRemove}
                  displayValue='name'
                  reset={true}
                  showArrow={true}
                  customArrow={true}
                  avoidHighlightFirstOption={true}
                  placeholder='select status'
                />
            </Form.Group>
            <Form.Group className="mb-2">
                <Form.Label>From Date</Form.Label>
                <br />
                <DatePicker
                    selected={selectedFromDate}
                    dateFormat='dd/MM/yyyy'
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    onChange={(date) => handleFromDateChange(date)}
                    placeholderText="Select From Date"
                    className="font-size-12"
                />
            </Form.Group>
            <Form.Group className="mb-2">
                <Form.Label>To Date</Form.Label>
                <br />
                <DatePicker stateModel={filtersModel}
                    selected={selectedToDate}
                    dateFormat='dd/MM/yyyy'
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    onChange={(date) => handleToDateChange(date)}
                    placeholderText="Select To Date"
                    className="font-size-12"
                    minDate={selectedFromDate}
                />
            </Form.Group>
            {dateError && <div className='font-size-10 text-danger mb-2'>Please select from date first.</div>}
        </div>
    </Filters>
};

export default FiltersPartial;

